import { TITLE_SEPARATOR, TITLE_SUFFIX } from './constants'

export const makeTitle = (titles: string[], translator: (key: string) => string) => {
  const filterEmpty = (title: string = '') => title.trim().length > 0
  const suffix = translator(TITLE_SUFFIX)
  const separator = ` ${TITLE_SEPARATOR} `

  if (titles.length === 0) {
    return suffix
  }

  return titles.filter(filterEmpty).map(translator).join(separator)
}
